import { all, takeLatest } from 'redux-saga/effects';
import {
  FETCH_USER_REQUEST,
  CREATE_USER_REQUEST,
  UPDATE_USER_REQUEST,
  DELETE_USER_REQUEST,
  FETCH_USER_DETAILS_REQUEST,
  FETCH_AWARD_USER_REQUEST,
  FETCH_LUCKY_DRAW_USER_REQUEST,
  GET_PRODUCT_LIST_REQUEST
} from '../../types/user';
import {
  fetchUserWorker,
  createUserWorker,
  updateUserWorker,
  deleteUserWorker,
  fetchUserDetailsWorker,
  fetchAwardUserWorker,
  fetchLuckyDrawUserWorker,
  getProductListWorker
} from '../workers/userWorker';


export default function* userWatcher() {
  yield all([
    takeLatest(FETCH_USER_REQUEST, fetchUserWorker),
    takeLatest(CREATE_USER_REQUEST, createUserWorker),
    takeLatest(UPDATE_USER_REQUEST, updateUserWorker),
    takeLatest(GET_PRODUCT_LIST_REQUEST, getProductListWorker),
    takeLatest(DELETE_USER_REQUEST, deleteUserWorker),
    takeLatest(FETCH_USER_DETAILS_REQUEST, fetchUserDetailsWorker),
    takeLatest(FETCH_AWARD_USER_REQUEST, fetchAwardUserWorker),
    takeLatest(FETCH_LUCKY_DRAW_USER_REQUEST, fetchLuckyDrawUserWorker),
  ]);
}
